import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';
import { colors } from 'styles/colors';
import { colorByCategory } from '../../helpers';
import { EfficiencyCategory } from '../../types';
import { CircleCategory, TooltipContainer } from './styles';

interface EnergyEfficiencyTooltipProps {
  category: EfficiencyCategory;
  disabled: boolean;
}

export function EnergyEfficiencyTooltip({
  category,
  disabled,
}: Readonly<EnergyEfficiencyTooltipProps>): ReactElement {
  const { t } = useTranslation();

  return (
    <ReactTooltip
      id={`tooltip-efficiency-${category.toLowerCase()}`}
      place="right"
      effect="solid"
      type="dark"
      delayHide={100}
      backgroundColor={colors.bg['weak-100']}
      padding="4px"
      className="tooltip-efficiency"
      disable={disabled}
    >
      <TooltipContainer>
        <CircleCategory color={colorByCategory(category)} />
        <span>{category}</span>
        <span>{t('cliqueVerMaisDetalhes')}</span>
      </TooltipContainer>
    </ReactTooltip>
  );
}
